<template>
	<div>
		<div class="form-row">
		    <div class="form-group col-md-12">
		        <label>Nome *</label>
		        <input
		        	type="text"
		        	class="form-control"
		        	v-model="dados.nome"
		        	:id="name+'nome'"
		        	@input="clearValidation('nome')">
		        <div class="invalid-feedback" :id="name+'nome-invalid-feedback'"></div>
		    </div>
		</div>
		<div class="form-row">
			<div class="form-group col-md-6">
		        <label>Categoria</label>
		        <select-two
		        	:options="categorias"
		        	:formId="name+'categ_produto_id'"
		        	:valueDefault="dados.categoria"
		        	@selected="setCategProdutoId"
		        	@searching="getCategorias"
		        	arrayValue="nome">
		        </select-two>
		    </div>
		    <div class="form-group col-md-5">
		        <label>Valor *</label>
                <money
                    :id="name+'valor'"
                    class="form-control"
                    v-model="dados.valor"
                    @input="clearValidation('valor')">
                </money>
		        <div class="invalid-feedback" :id="name+'valor-invalid-feedback'"></div>
		    </div>
		    <div class="form-group col-md-1">
		        <label>Site</label>
		        <toggle
		        	id="produtoAtivoToggle"
		        	:key="toggleKey"
		        	:default="dados.ativo_site"
		        	@tchange="setAtivoSite">
		        </toggle>
		        <div class="invalid-feedback" :id="name+'valor-invalid-feedback'"></div>
		    </div>
		</div>
		<div class="form-row">
		    <div class="form-group col-md-12">
		        <label>Descrição Interna</label>
				<vue-editor v-model="dados.descricao"></vue-editor>
				<small class="form-text text-muted">Descrição utilizada apenas para fins de gestão interna.</small>
		    </div>
		</div>
		<div class="form-row">
		    <div class="form-group col-md-12">
		        <label>Descrição para o Site</label>
				<vue-editor v-model="dados.descricao_site"></vue-editor>
				<small class="form-text text-muted">Esta descrição será exibida publicamente na página do produto no site.</small>
		    </div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dados', 'name', 'errors'],
		data(){
			return {
				elementos: Object.keys(this.dados),
				categorias: [],
				toggleKey: 1
			}
		},
		created(){
			this.getCategorias();
		},
		methods : {
			getCategorias(pesquisa=''){
				axios.get(this.$url+'/api/adm/categ-produtos/list?pesquisa='+pesquisa)
	            .then(response => {
	                this.categorias = response.data.data.data
	            })
			},
			setCategProdutoId(valor){
				this.dados.categ_produto_id = valor.id;
			},
			setAtivoSite(valor){
				this.dados.ativo_site = valor;
			},
			clearValidation(element){
				this.$bshValidation.clear(element, this.name);
			}
        },
        watch: {
            errors: function() {
                this.$bshValidation.valide(this.elementos, this.errors, this.name);
            },
            dados(){
            	this.toggleKey += 1;
            }
        }
    }
</script>
